import React, { useEffect } from "react";
import { Sparklines, SparklinesCurve, SparklinesSpots } from "react-sparklines";

const StockMiniChart = ({ 
    data = [], width = 1000, height = 300, maxDataPoints = 100, color = "#fff"
 }) => {
  // Use the passed data directly, limit to maxDataPoints
  const chartData = data.length > maxDataPoints ? data.slice(-maxDataPoints) : data;

  return (
    <Sparklines data={chartData} width={width} height={height} limit={maxDataPoints}>
      <SparklinesCurve color={color} style={{ strokeWidth: 3 }} />
      <SparklinesSpots color = {color} style={{strokeWidth: 5 }}/>
    </Sparklines>
  );
};

export default StockMiniChart;